module.exports = __webpack_public_path__ + "static/media/postgres.a0a10cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/postgres.png
// module id = 115
// module chunks = 0